import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TypeHeadElement } from '@classes/models';
import {
    FonctionUSR, Organisme, OrganismeService as OrganismesService,
    PointageService,
    RFFonction,
    Utilisateur
} from '@estel-numerique/galaclick-api';
import { DateHelper, GalaclickError, SelectOption } from '@estel-numerique/galaclick-core';
import { Constantes } from '@services/util/constantes';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '@classes/extends';
import { FormValidator } from '@composants/validators';
import { addDays, isAfter, isBefore, isEqual, subDays } from 'date-fns';
import { lastValueFrom } from 'rxjs';
import { Periode } from '../models/Periode.model';
import { DialogGalaComponent } from '../../composants/dialog-gala/dialog-gala.component';
import { SelectGala } from '../../composants/select/select.component';
import { InputGala } from '../../composants/inputs/input.component';
import { DateGalaComponent } from '../../composants/date-gala/date-gala.component';
import { MatButton } from '@angular/material/button';


export interface UtilisateurFonctionComponentData {
    user: Utilisateur;
    fonction?: FonctionUSR;

}

@Component({
    templateUrl: './utilisateurFonction.component.html',
    imports: [DialogGalaComponent, FormsModule, ReactiveFormsModule, SelectGala, InputGala, DateGalaComponent, MatButton]
})
export class UtilisateurFonctionComponent extends BaseComponent implements OnInit {
    private formBuilder = inject(FormBuilder);
    private wsOrga = inject(OrganismesService);
    public wsPointage = inject(PointageService);
    private dialogRef = inject<MatDialogRef<UtilisateurFonctionComponent>>(MatDialogRef);
    public data = inject<UtilisateurFonctionComponentData>(MAT_DIALOG_DATA);

    public codeModule: string = Constantes.CodeOption.OFICHIERUSER;
    public titre: string;
    public listeORGA: Organisme[] = [];
    public listeFONCTION: RFFonction[];
    public headElementsFoncitons: TypeHeadElement[] = [];

    protected lgTrad: Record<string, string> = {};        // Traduction formulaire principal
    protected lgTradFct: Record<string, string> = {};     // Traduction Volet Employeur et fonction

    public types: SelectOption<number>[];
    public typesSave: SelectOption<number>[];

    public user: Utilisateur;
    public fonction: FonctionUSR = null;
    private type = "de la fonction";

    @Output() modification = new EventEmitter<FonctionUSR[]>();

    public formFonction = this.formBuilder.group({
        TYPEFCT: [0, [Validators.required]], // CORRESPOND A PRINCIPAL DANS L'OBJET MAIS POSE TROP GENERIQUE POUR LA TRAD FORMERROR
        FONCTION: [null as number, [Validators.required]],
        ORGANISME: [null as number, [Validators.required, FormValidator.etpSupZero]],
        ETP: [null as number, [Validators.required, Validators.max(100)]],
        COOCTAGRI: ['', [Validators.maxLength(20)]],
        DDEBUT: ['', [Validators.required, FormValidator.validDate]],
        DFIN: ['', [FormValidator.validDate]],
    }, { validators: [this.util.date.compareDate('DDEBUT', 'DFIN')] });



    constructor() {
        super();
        this.dialogRef.updateSize('980px');
        this.user = this.data.user;
        this.typesSave = [
            new SelectOption(0, this.translate.instant("APPUTILISATEUR.SECONDAIRE")),
            new SelectOption(1, this.translate.instant("APPUTILISATEUR.PRINCIPAL"))
        ];
        this.types = Object.assign([], this.typesSave);
        this.lgTrad = {
            ENR: this.translate.instant('ENR'),
            RET: this.translate.instant('RET')
        };
        this.lgTradFct = {
            EMPNFCT: this.translate.instant('APPUTILISATEUR.FUNCTION.EMPNFCT'),
            FONCTION: this.translate.instant('APPUTILISATEUR.FUNCTION.FUNCTION'),
            EMPLOYER: this.translate.instant('APPUTILISATEUR.FUNCTION.EMPLOYER'),
            ETP: this.translate.instant('APPUTILISATEUR.FUNCTION.ETP'),
            ETPPOURC: this.translate.instant('APPUTILISATEUR.FUNCTION.ETPPOURC'),
            OCTAGRI: this.translate.instant('APPUTILISATEUR.FUNCTION.OCTAGRI'),
            OCTAGRICODE: this.translate.instant('APPUTILISATEUR.FUNCTION.OCTAGRICODE'),
            ORGANISME: this.translate.instant('ORGANISME'),
            TYPE: this.translate.instant('APPUTILISATEUR.FUNCTION.TYPE'),
            DEBUT: this.translate.instant('DEBUT'),
            FIN: this.translate.instant('FIN'),
            BEGINNINGDATE: this.translate.instant('BEGINNINGDATE'),
            ENDDATE: this.translate.instant('ENDDATE'),
            CREAFCT: this.translate.instant('APPUTILISATEUR.FUNCTION.CREAFCT'),
            MODIFFCT: this.translate.instant('APPUTILISATEUR.FUNCTION.MODIFFCT'),
            DELETEFCT: this.translate.instant('APPUTILISATEUR.FUNCTION.DELETEFCT')
        };
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.showModalFonction(this.data).catch(e => this.util.fErreur(e));
    }


    private async showModalFonction(oData?: UtilisateurFonctionComponentData) {
        try {
            this.util.showLoader();
            const tabRes = await Promise.all([
                lastValueFrom(this.wsCacheLow.getRFFonction()),
                lastValueFrom(this.wsOrga.getOrganismes(true))
            ]);
            this.listeFONCTION = tabRes[0];
            this.listeORGA = tabRes[1];
            const fonction = oData.fonction;
            if (fonction != null) {
                this.fonction = fonction;
                this.formFonction.reset({
                    COOCTAGRI: this.fonction.COOCTAGRI,
                    DDEBUT: this.fonction.DDEBUT,
                    DFIN: this.fonction.DFIN,
                    ETP: this.fonction.ETP,
                    FONCTION: this.fonction.FONCTION.IDFONCTION,
                    ORGANISME: this.fonction.ORGANISME.IDORGA
                });
                this.formFonction.get('TYPEFCT').setValue(this.typesSave[fonction.PRINCIPAL].value);
                this.formFonction.get('TYPEFCT').disable();
                if (this.fonction.DFIN) {
                    this.formFonction.get('DDEBUT').disable();
                }
            } else {
                let boPrinc = true;
                if (this.user.FONCTIONS) {
                    this.user.FONCTIONS.forEach((f: FonctionUSR) => {
                        if (f.PRINCIPAL == 1 && (f.DFIN == null || new Date(f.DFIN) > new Date())) {
                            boPrinc = false;
                        }
                    });
                }
                if (boPrinc) {
                    this.formFonction.get('TYPEFCT').setValue(this.types[1].value);

                } else {
                    this.formFonction.get('TYPEFCT').setValue(this.types[0].value);
                }
                this.formFonction.get('ETP').setValue(100);
            }


            if ((fonction?.PRINCIPAL != 1) &&
                this.user.FONCTIONS?.find((fct: FonctionUSR) => { return fct.PRINCIPAL == 1 && fct.DFIN == null; }) != null) {
                // On filtre les choix pour ne proposer que Secondaire
                this.types = [this.typesSave[0]];

                if (fonction == null) {
                    this.formFonction.get('TYPEFCT').setValue(this.typesSave[0].value);
                }
            } else {
                this.types = Object.assign([], this.typesSave);
            }
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }

    public hideModalFonction() {
        this.formFonction.reset();
        this.formFonction.markAsUntouched();
        this.formFonction.markAsPristine();
        this.fonction = null;
        this.dialogRef.close();
    }

    public async addFonction(): Promise<void> {
        if (this.formFonction.invalid) {
            this.util.showToastError(this.translate.instant('APPUTILISATEUR.FUNCTION.INVALIDFORM'));
            this.formFonction.markAllAsTouched();
            return;
        }
        const nouvelleFonction: FonctionUSR = this.preparerDonneesFonction();
        const periodeFonction = new Periode(nouvelleFonction.DDEBUT, nouvelleFonction.DFIN);
        const soustraction = periodeFonction.soustraire(new Periode(this.user.DDEBUT, this.user.DFIN));
        if (soustraction) {
            if (soustraction.length == 1) {
                const periodeMsg = soustraction[0].formatEuropeen();
                this.util.showToastError(
                    this.translate.instant('APPUTILISATEUR.DEPPERUTIL.SIMPLE')
                        .replace('{periode}', periodeMsg)
                        .replace('{type}', this.type)
                );
            }
            else {
                const periodeMsg = soustraction.map(p => p.formatEuropeen()).join(', ');
                this.util.showToastError(
                    this.translate.instant('APPUTILISATEUR.DEPPERUTIL.MULTI')
                        .replace('{periodes}', periodeMsg)
                        .replace('{type}', this.type)
                );
            }
            return;
        }


        if (nouvelleFonction.ETP < 1 || nouvelleFonction.ETP > 100) {
            this.util.showToastError(this.translate.instant('APPUTILISATEUR.FUNCTION.ETPERR'));
            return;
        }
        this.user.FONCTIONS = this.user.FONCTIONS || [];
        try {
            // Si une fonction existe déjà dans this.data.fonction, on considère cela comme une modification.
            await this.traiterFonction(nouvelleFonction, periodeFonction, this.data.fonction);
            this.modification.emit(this.user.FONCTIONS);
            this.hideModalFonction();
        } catch (error) {
            if (error instanceof GalaclickError) {
                this.util.showToastError(error.message);
            } else {
                this.util.fErreur(error);
            }
        }
    }

    /**
     * Prépare les données de la fonction à partir du formulaire
     */
    private preparerDonneesFonction(): FonctionUSR {
        const form = this.formFonction;
        return {
            FONCTION: this.listeFONCTION.find(f => f.IDFONCTION === form.get('FONCTION').value),
            ORGANISME: this.listeORGA.find(o => o.IDORGA === form.get('ORGANISME').value),
            ETP: form.get('ETP').value,
            COOCTAGRI: form.get('COOCTAGRI').value,
            DDEBUT: form.get('DDEBUT').value,
            DFIN: form.get('DFIN').value,
            PRINCIPAL: form.get('TYPEFCT').value
        };
    }

    /**
     * Traite la création ou la modification d'une fonction.
     * Si "fonctionActuelle" est fourni, on modifie ; sinon, on crée.
     */
    private async traiterFonction(
        nouvelleFonction: FonctionUSR,
        periodeFonction: Periode,
        fonctionActuelle?: FonctionUSR
    ): Promise<void> {
        // Pour une création, on vérifie que la fonction n'existe pas déjà.
        if (!fonctionActuelle && this.fonctionExisteDeja(nouvelleFonction)) {
            throw new GalaclickError(this.translate.instant('APPUTILISATEUR.FUNCTION.ALREADYEXISTS'));
        }

        if (nouvelleFonction.PRINCIPAL === 1) {
            // Traitement pour une fonction principale
            const fonctionsPrincipales = this.user.FONCTIONS.filter(f => f.PRINCIPAL === 1 && f !== fonctionActuelle);
            const chevauchement = fonctionsPrincipales.reduce<Periode | null>((trouve, f) => {
                if (trouve) return trouve;
                const periodeAutre = new Periode(f.DDEBUT, f.DFIN);
                return periodeFonction.ontDesJoursEnCommun(periodeAutre)
                    ? periodeFonction.getJoursEnCommun(periodeAutre)
                    : null;
            }, null);
            if (chevauchement) {
                throw new GalaclickError(
                    this.translate.instant('APPUTILISATEUR.FUNCTION.INVALIDPERIODPRINC') +
                    chevauchement.formatEuropeen()
                );
            }
            // Si la modification change les dates, vérifier l'impact sur les fonctions secondaires.
            if (fonctionActuelle &&
                (fonctionActuelle.DDEBUT !== nouvelleFonction.DDEBUT || fonctionActuelle.DFIN !== nouvelleFonction.DFIN)) {
                this.verifierImpactSurFonctionsSecondaires(periodeFonction, fonctionActuelle);
            }
        } else {
            // Traitement pour une fonction secondaire
            const fonctionsPrincipales = this.user.FONCTIONS.filter(f => f.PRINCIPAL === 1);
            if (fonctionsPrincipales.length === 0) {
                throw new GalaclickError(
                    this.translate.instant('APPUTILISATEUR.FUNCTION.NOFCTPRINC') +
                    periodeFonction.formatEuropeen()
                );
            }
            // Fusionner les périodes des fonctions principales pour obtenir la couverture totale
            const periodesPrincipales = fonctionsPrincipales.map(f => new Periode(f.DDEBUT, f.DFIN));
            const fusionPrincipale = Periode.fusionDePeriodes(periodesPrincipales);
            // Calculer l'intervalle non couvert (le gap) de la fonction secondaire par rapport à la couverture principale
            const ecart = periodeFonction.trouverDebordement(fusionPrincipale);
            if (ecart) {
                throw new GalaclickError(
                    this.translate.instant('APPUTILISATEUR.FUNCTION.NOFCTPRINC') +
                    ecart.formatEuropeen()
                );
            }
        }

        const fonctionsAComparer = fonctionActuelle
            ? this.user.FONCTIONS.filter(f => f !== fonctionActuelle)
            : this.user.FONCTIONS;
        const periodeETPExcessive = this.verifierETP(nouvelleFonction, periodeFonction, fonctionsAComparer);
        if (periodeETPExcessive) {
            throw new GalaclickError(
                this.translate.instant('APPUTILISATEUR.ETPLIMIT>') +
                periodeETPExcessive.formatEuropeen()
            );
        }

        if (fonctionActuelle) {
            try {
                await lastValueFrom(this.wsPointage.verifierActivites(this.user.USRID,
                    fonctionActuelle.DDEBUT,
                    nouvelleFonction.DDEBUT,
                    fonctionActuelle.ETP != nouvelleFonction.ETP,
                    fonctionActuelle.DFIN,
                    nouvelleFonction.DFIN
                ));
            } catch (e) {
                this.formFonction.get('ETP').setValue(fonctionActuelle.ETP);
                throw e;
            }
            this.remplacerFonction(fonctionActuelle, nouvelleFonction);
        } else {
            this.user.FONCTIONS.push(nouvelleFonction);
        }
    }


    /**
     * Vérifie si une fonction identique existe déjà.
     */
    private fonctionExisteDeja(fonction: FonctionUSR): boolean {
        return this.user.FONCTIONS.some(f =>
            f.FONCTION.IDFONCTION === fonction.FONCTION.IDFONCTION &&
            f.ORGANISME.IDORGA === fonction.ORGANISME.IDORGA &&
            f.DDEBUT === fonction.DDEBUT
        );
    }

    /**
     * Vérifie l'impact sur les fonctions secondaires lors de la modification d'une fonction principale.
     */
    private verifierImpactSurFonctionsSecondaires(nouvellePeriode: Periode, fonctionActuelle: FonctionUSR): void {
        const periodeActuelle = new Periode(fonctionActuelle.DDEBUT, fonctionActuelle.DFIN);
        const periodesPrincipales = [
            ...this.user.FONCTIONS
                .filter(f => f.PRINCIPAL === 1 && f !== fonctionActuelle)
                .map(f => new Periode(f.DDEBUT, f.DFIN)),
            nouvellePeriode
        ];
        const mergedMain = Periode.fusionDePeriodes(periodesPrincipales);
        for (const f of this.user.FONCTIONS.filter(fct => fct.PRINCIPAL === 0)) {
            const pSec = new Periode(f.DDEBUT, f.DFIN);
            if (pSec.estContenuDans(periodeActuelle)) {
                const debordement = pSec.trouverDebordement(mergedMain);
                if (debordement) {
                    throw new GalaclickError(
                        this.translate.instant('APPUTILISATEUR.FUNCTION.SECONDARY_NOT_CONTAINED') +
                        debordement.formatEuropeen()
                    );
                }
            }
        }
    }


    /**
    * Vérifie que l'ETP total ne dépasse pas 100% sur une période donnée.
    * @returns La période problématique ou null si aucun problème.
    */
    private verifierETP(
        fonction: FonctionUSR,
        periodeFonction: Periode,
        fonctionsAComparer: FonctionUSR[] = this.user.FONCTIONS
    ): Periode | null {
        const fonctionsEnCommun = fonctionsAComparer.filter(f =>
            periodeFonction.ontDesJoursEnCommun(new Periode(f.DDEBUT, f.DFIN))
        );
        if (fonctionsEnCommun.length === 0) return null;
        const dates = this.collecterDatesImportantes(periodeFonction, fonctionsEnCommun);

        let adjustedDateDebut = subDays(periodeFonction.debut, 1);

        for (const DateCourante of dates) {
            const intervalDebut = addDays(adjustedDateDebut, 1);
            const intervalFin = DateCourante;
            if (intervalFin === null || isAfter(intervalFin, intervalDebut) || isEqual(intervalFin, intervalDebut)) {
                const periodeIntervalle = new Periode(intervalDebut, intervalFin);
                const etpTotal = this.calculerEtpIntervalle(fonction, fonctionsEnCommun, periodeIntervalle);
                if (etpTotal > 100) {
                    return periodeIntervalle;
                }
                adjustedDateDebut = DateCourante;
            }
        }
        const lastIntervalStart = addDays(adjustedDateDebut, 1);
        const lastIntervalEnd = periodeFonction.fin;
        if (lastIntervalEnd === null
            || isAfter(lastIntervalEnd, lastIntervalStart)
            || isEqual(lastIntervalEnd, lastIntervalStart)) {

            const periodeIntervalle = new Periode(lastIntervalStart, lastIntervalEnd);
            const etpTotal = this.calculerEtpIntervalle(fonction, fonctionsEnCommun, periodeIntervalle);
            if (etpTotal > 100) {
                return periodeIntervalle;
            }
        }
        return null;
    }

    /**
     * Collecte toutes les dates importantes (début et fin) pour l'analyse de l'ETP.
     * Pour les dates de début, la date est ajustée d'un jour en arrière (date réelle – 1).
     * Les doublons sont éliminés et les dates sont triées dans l'ordre chronologique.
     */
    private collecterDatesImportantes(
        periode: Periode,
        fonctions: FonctionUSR[]
    ): Date[] {
        let dates: Date[] = [];
        dates.push(DateHelper.dayAdd(periode.debut, -1));
        if (periode.fin) {
            dates.push(periode.fin);
        }
        fonctions.forEach(f => {
            const p = new Periode(f.DDEBUT, f.DFIN);
            if (periode.ontDesJoursEnCommun(p)) {
                if (!periode.fin || !isAfter(f.DDEBUT, periode.fin)) {
                    dates.push(DateHelper.dayAdd(new Date(f.DDEBUT), -1));
                }
                if (f.DFIN && (!periode.debut || !isBefore(f.DFIN, periode.debut))) {
                    dates.push(new Date(f.DFIN));
                }
            }
        });

        dates = dates.filter((d, index, self) =>
            index === self.findIndex((t) => t.getTime() === d.getTime())
        );
        dates.sort((a, b) => a.getTime() - b.getTime());
        return dates;
    }

    /**
    * Calcule l'ETP total pour un intervalle donné.
    */
    private calculerEtpIntervalle(
        fonctionPrincipale: FonctionUSR,
        fonctions: FonctionUSR[],
        intervalle: Periode
    ): number {
        let total = Number(fonctionPrincipale.ETP) || 0;
        fonctions.forEach(f => {
            const p = new Periode(f.DDEBUT, f.DFIN);
            if (p.ontDesJoursEnCommun(intervalle)) {
                total += Number(f.ETP) || 0;
            }
        });
        return total;
    }

    /**
     * Remplace une fonction par sa nouvelle version.
     */
    private remplacerFonction(ancienne: FonctionUSR, nouvelle: FonctionUSR): void {
        const index = this.user.FONCTIONS.indexOf(ancienne);
        if (index !== -1) {
            this.user.FONCTIONS[index] = nouvelle;
        }
    }
}
